import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild} from "@angular/core";
import {BehaviorSubject} from "rxjs";

import countries from './countries.json';

@Component({
  selector: 'int-phone-input',
  templateUrl: './int-phone-input.component.html',
  styleUrls: ['./int-phone-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntPhoneInputComponent implements AfterViewInit, OnInit {

  @Input() placeholder = '';

  @ViewChild('container') private readonly container!: ElementRef;


  defaultDropdownWidth = 200;

  containerRectData$ = new BehaviorSubject<{width: number}>({width: this.defaultDropdownWidth});

  list$ = new BehaviorSubject<{value: any, label: any}[]>([...this.createList()]);

  createList() {
    return Object.entries(countries).map((country) => {
      return {
        value: country[0],
        label: country[1]
      }
    })
  }

  ngOnInit() {
    console.log(this.createList());
  }

  ngAfterViewInit() {
    const {width} = this.container.nativeElement.getBoundingClientRect();
    this.containerRectData$.next({
      width: width || this.defaultDropdownWidth
    })
  }

}
